module.exports = __webpack_public_path__ + "img/jqr.4ae86cdb.png";